<template>
  <div class="container">
    <p>
      <strong>{{ t('BtuImportantNote') }}</strong>
      {{ t('BtuWattageExplanation') }}
    </p>
    <p>{{ t('btuCalculationAssumption') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('singleLightWattage')"
          v-model.number="lightWattage"
          :unit="t('watts')"
        />
        <FixedUnitInput
          :input-label="t('lightCount')"
          v-model.number="lightCount"
          :unit="t('lights')"
        />
        <FixedUnitInput
          :input-label="t('co2GeneratorBTUs')"
          v-model.number="co2BTUs"
          :unit="t('btus')"
        />
        <FixedUnitInput
          :input-label="t('co2Generators')"
          v-model.number="co2Count"
          :unit="t('generators')"
        />
        <FixedUnitInput
          :input-label="t('dehumidifierWattage')"
          v-model.number="dehumWattage"
          :unit="t('watts')"
        />
        <FixedUnitInput
          :input-label="t('dehumidifiers')"
          v-model.number="dehumCount"
          :unit="t('dehumidifiers')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('btusPerHour')"
          :number="totalBTUs"
          :unit="t('btus')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
      const lightWattage = ref(700);
      const lightCount = ref(10);
      const co2BTUs = ref(17000);
      const co2Count = ref(1);
      const dehumWattage = ref(300);
      const dehumCount = ref(1);


      const { t, tm } = useI18n();

        // Create a reactive object with a function
        const translations = reactive({
          t: (key) => t(key)
        })

        const equations = computed(() => {
            return tm('BtcCalcEquations');
        })

  
      const totalBTUs = computed(() => {
        const BTUsPerWatt = 3.412;
        const totalLightWattage = lightWattage.value * lightCount.value;
        const totalCo2BTUs = co2BTUs.value * co2Count.value;
        const totalDehumWattage = dehumWattage.value * dehumCount.value;
  
        return defaultRound((totalLightWattage + totalDehumWattage) * BTUsPerWatt + totalCo2BTUs);
      });
  
      return {
        lightWattage,
        lightCount,
        co2BTUs,
        co2Count,
        dehumWattage,
        dehumCount,
        totalBTUs,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  